import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment';
import { Server } from '../../../../shared/models/server.models';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { GroupData } from '../../../../shared/models/group-overview.model';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-group-information',
  imports: [
    MatCardModule,
    FontAwesomeModule,
    MatButtonModule,
    MatTooltipModule,
    ClipboardModule,
    NgClass,
    RouterLink,
    MatMenuModule,
  ],
  templateUrl: './group-information.component.html',
  styleUrl: './group-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupInformationComponent {
  private snackbar = inject(MatSnackBar);

  groupData = input.required<GroupData>();

  websiteGroup = computed(() => this.groupData().websiteGroup);

  server = input<Server | null>();

  // sshLogin = computed(() => `sshpass -p '${password}' ssh ${username}@${server}`)

  groupInfo = [
    {
      label: 'ID',
      text: (value: GroupData) => value.websiteGroup.id,
    },
    {
      label: 'Plan',
      text: (value: GroupData) => value.hostingPlan.name,
    },
    {
      label: 'Main domain',
      text: (value: GroupData) => value.websiteGroup.mainWebsite?.domain,
      class: () => 'link',
      tooltip: () => 'Go to main site settings',
      routerLink: (value: GroupData) => `/overview/${value.websiteGroup.mainWebsite?.id}`,
    },
    {
      label: 'Used site slots',
      text: (value: GroupData) =>
        `${value.websites.length} / ${value.hostingPlan.websitesCountLimit}`,
    },
    {
      label: 'SSH user',
      text: (value: GroupData) => value.systemUser.name,
    },
    {
      label: 'Created At',
      text: (value: GroupData) =>
        moment(value.websiteGroup.mainWebsite?.createdAt).format('DD.MM.YYYY, hh:mm:ss'),
    },
  ];

  migrateGroup = output();

  changePlan = output();

  onCopied(success: boolean) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: 'SSH Login copied!',
        },
      });
    }
  }
}
